import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const Despatch = ({ match }) => {
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [name, setName] = useState("");
    const [startAutometereReading, setStartAutometereReading] = useState("");
    const [endAutometereReading, setEndAutometereReading] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [customername, setcustomername] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [saleDescription, setsaledescription] = useState("");
    const [remarks, setRemarks] = useState("");
    const [BillAmount, setbillamount] = useState("");
    const [SaleAmount, setpendingamount] = useState("");
    const [amount, setpaidamount] = useState("");
    const [saleTotalAmount, setAmount] = useState("");
    const [formData, setFormData] = useState({});
    const [despatchdate, setDespatchDate] = useState("");
    const [despatchno, setdespatchno] = useState("");
    const [paymentType, setPaymentType] = useState("credit");
    const [BalanceAmount, setbalanceamount] = useState([]);
    const [data, setData] = useState(null);
    const [deliveryData, setDeliveryData] = useState({});
    const [invoiceDetails, setInvoiceDetails] = useState([]);
    const [selectedPaymentType, setSelectedPaymentType] = useState("1");
    const [CustomerId, setCustomer] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedCustomerData, setSelectedCustomerData] = useState(null);

    const [ReturnAmount, setreturnamount] = useState(0);

    useEffect(() => {
        fetchTableDataDelivery();
    }, []);

    const fetchTableDataDelivery = async () => {
        try {
            // Fetch initial delivery sale data
            const initialResponse = await fetchData('DeliverySaleApi', `/${id}`, token);

            if (initialResponse.responseCode === '1111') {
                const deliveryData = initialResponse.response_data;

                setFormData(deliveryData.PaymentAndReceipt);
                setInvoicedeatils(deliveryData.PaymentAndReceiptSale);

                const updatedInvoicedetailsSorted = deliveryData.PaymentAndReceiptSale;

                const totalSaleAmount = updatedInvoicedetailsSorted.reduce((total, invdetail) => {
                    return invdetail.IsType === true ? total + invdetail.SaleAmount : total;
                }, 0);

                // Find chequefine (assuming it exists in one of the objects)
                const chequefine = updatedInvoicedetailsSorted.find(
                    (item) => item.Chequefine !== undefined
                )?.Chequefine || 0;

                const totalReturnAmount = updatedInvoicedetailsSorted.reduce((total, invdetail) => {
                    return invdetail.IsType === false ? total + invdetail.SaleAmount : total;
                }, 0);


                // Update formData with total SaleAmount
                setFormData((prevData) => ({
                    ...prevData,
                    TotalBalAmt: totalSaleAmount,
                    ReturnTotalAmt: totalReturnAmount,
                    Chequefine:chequefine,
                    //PaymentTypeId: 6,
                }));
                setreturnamount(totalReturnAmount);


                console.log(initialResponse);
                // Fetch additional sale data            

            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }

    }, [isAuthenticated, token, logout]);

    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState(null);

    //const [selectedCustomer, setSelectedCustomer] = useState(null);
    useEffect(() => {
        fetchBankTypes();
    }, [companyId, token]); // Fetch bank options on component load or when companyId/token changes


    const fetchBankTypes = async () => {
        try {
            const response = await fetchData('Bank', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(bank => {
                    // Ensure AccountNumber exists and has at least 4 characters
                    const lastFourDigits = bank.AccountNo && bank.AccountNo.length >= 4
                        ? bank.AccountNo.slice(-4)
                        : '';

                    // Check for specific last four digits for Rice and Food
                    let labelSuffix;
                    if (lastFourDigits === '5826') {
                        labelSuffix = 'Rice';
                    } else if (lastFourDigits === '6725') {
                        labelSuffix = 'Food';
                    } else {
                        labelSuffix = ''; // You can set a default suffix or leave it blank
                    }

                    return {
                        value: bank.Id,
                        label: `${bank.BankName}${labelSuffix ? ' - ' + labelSuffix : ''}`, // Conditionally add suffix if present
                    };
                });
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching bank options:', error);
        }
    };


    const handleBankTypeChange = (selectedOption) => {
        setSelectedBank(selectedOption);
    };
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [customerOptions, setCustomerOptions] = useState([]);
    //const [selectedCustomer, setSelectedCustomer] = useState(null);

    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleRouteWiseCustomerChange = async (selectedOption) => {
        setSelectedRoute(selectedOption);
        setSelectedCustomer(null); // Reset customer selection
        try {
            const response = await fetchData('CustomerApi', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                const customerOptions = response.response_data.map(customer => ({
                    value: customer.id,
                    label: customer.name
                }));
                setCustomerOptions(customerOptions);
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };



    useEffect(() => {
        fetchRouteTypes();
    }, []);


    const [invoicedeatils, setInvoicedeatils] = useState([]);
    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);

        setFormData((prevData) => ({
            ...prevData,
            PartyId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (selectedOption) {
            fetchData('DeliverySaleApi', `/${companyId}/${selectedOption.value}`, token)
                .then((response) => {
                    if (response.responseCode === '1111') {

                        const updatedInvoicedetailsSorted = response.response_data;

                        const totalSaleAmount = updatedInvoicedetailsSorted.reduce((total, invdetail) => {
                            return invdetail.IsType === true ? total + invdetail.SaleAmount : total;
                        }, 0);

                        // Find chequefine (assuming it exists in one of the objects)
                        const chequefine = updatedInvoicedetailsSorted.find(
                            (item) => item.Chequefine !== undefined
                        )?.Chequefine || 0;

                        const totalReturnAmount = updatedInvoicedetailsSorted.reduce((total, invdetail) => {
                            return invdetail.IsType === false ? total + invdetail.SaleAmount : total;
                        }, 0);


                        // Update formData with total SaleAmount
                        setFormData((prevData) => ({
                            ...prevData,
                            TotalBalAmt: totalSaleAmount,
                            ReturnTotalAmt: totalReturnAmount,
                            Chequefine: chequefine,
                        }));
                        setreturnamount(totalReturnAmount);
                        setInvoicedeatils(updatedInvoicedetailsSorted);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching invoice details:', error);
                });



            fetchData('DeliverySaleApi', `/Advanceamount/${companyId}/${selectedOption.value}`, token)
                .then((response) => {
                    if (response.responseCode === '1111') {

                        let adamt = response.response_data.AdvanceAmount;


                        setFormData((prevData) => ({
                            ...prevData,
                            UsedAdvanceAmt: adamt,
                        }));

                    }
                })
                .catch((error) => {
                    console.error('Error fetching invoice details:', error);
                });

        }

    };

    const closeModal = () => {
        setShowModal(false);
    };



    useEffect(() => {
        setDespatchDate(new Date().toISOString().split('T')[0]);
    }, []);



    //customer Payment Method 

    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");
    const [showBankField, setShowBankField] = useState(false);
    const fetchPaymentmethodTypes = async () => {
        try {
            const response = await fetchData('PaymentMethodApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setPaymentmethodOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentmethodType(selectedOption);

        // Show the bank field if the selected payment type is "Cheque", "RTGS", or "NEFT"
        if (["Cheque", "RTGS", "NEFT"].includes(selectedOption.label)) {
            setShowBankField(true);
        } else {
            setShowBankField(false);
        }
    };
    useEffect(() => {
        fetchPaymentmethodTypes();
    }, []);



    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (name === 'Amount') {

            if (value === '' || (value.length <= 8 && !isNaN(parseFloat(value)))) {
                let returnAmt = parseFloat(formData.ReturnTotalAmt);
                let usedAdvanceAmt = parseFloat(formData.UsedAdvanceAmt);

                let newAmount = parseFloat(value);
                if (isNaN(newAmount)) {
                    newAmount = 0;
                }
                if (isNaN(returnAmt)) {
                    returnAmt = 0;
                }

                if (isNaN(usedAdvanceAmt)) {
                    usedAdvanceAmt = 0;
                }
                // Update formData with the entered amount directly
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: type === 'checkbox' ? checked : newAmount,
                }));

                // Initialize remaining balance to the entered amount
                let remainingBalance = newAmount + returnAmt + usedAdvanceAmt;

                let totbal = parseFloat(formData.TotalBalAmt);
                let advanamt = 0;
                if (remainingBalance > totbal) {
                    advanamt = totbal - remainingBalance;
                }

                setFormData((prevData) => ({
                    ...prevData,
                    AdvanceAmt: advanamt,
                }));

                // Loop through each row in invoicedeatils
                const updatedInvoicedeatils = invoicedeatils.map((invdetail) => {
                    // Add a check to ensure invdetail and its SaleAmount property exist
                    if (invdetail && invdetail.SaleAmount && invdetail.IsType) {
                        // Perform the necessary calculation for IsType=true record
                        const amountForThisRow = Math.min(invdetail.SaleAmount, remainingBalance);
                        remainingBalance -= amountForThisRow;

                        // Ensure invdetail.Amount does not exceed invdetail.SaleAmount
                        const updatedAmount = Math.min(amountForThisRow, invdetail.SaleAmount);

                        // Calculate the balance amount for this row (ensure it's not negative)
                        const balanceForThisRow = Math.max((invdetail.SaleAmount - updatedAmount), 0).toFixed(2);

                        // Return the updated row
                        return {
                            ...invdetail,
                            Amount: updatedAmount,
                            BalanceAmount: balanceForThisRow,
                            pending: balanceForThisRow,
                        };
                    }
                    // Return the original invdetail if it's not valid
                    return invdetail;
                });

                // Update invoicedeatils with the updated values
                setInvoicedeatils(updatedInvoicedeatils);
            }
        } else if (name === 'PaymentType') {
            // Handle changes for the Payment Type radio buttons
            const newPaymentType = value;

            setSelectedPaymentType(newPaymentType);

            setFormData((prevData) => ({
                ...prevData,
                PaymentType: newPaymentType,
            }));
        } else {
            // For other form fields, update formData directly
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    };





    const [filteredData, setFilteredData] = useState([]);
    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            CompanyId: companyId,
            ReferenceDate: formattedDate,
            //ChequeDate: formattedDate,
            PaymentType: selectedPaymentmethodType.value,

            //PartyId: CustomerId,
        }));
    }, []);


    const submitData = async (e) => {
        setIsLoading(true);

        if (!formData.PartyId || formData.PartyId === 0) {
            setErrorMessage('Customer is required !');
            setIsLoading(false);
            return;
        }

        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }                                                                                  

        try {
            const mappedInvoiceDetails = invoicedeatils.map(item => ({
                ItemId: item.Id,
                PartyId: formData.PartyId,
                CompanyId: companyId,
                Amount: item.Amount,
                pending: item.BalanceAmount,
                IsType: item.IsType,
                SaleAmount: item.SaleAmount,
                CreatedBy: userId,
                SaleId: item.SaleId,
                SaleId1: item.SaleId1,
                // PaymentTypeId: selectedPaymentmethodType.value || formData.PaymentTypeId,
                // PaymentTypeId: selectedPaymentmethodType?.value ?? formData.PaymentTypeId,
                PaymentTypeId: selectedPaymentmethodType.value,
                CreatedDate: new Date(),

            }));

            const SALEID = invoicedeatils.SaleId;
            // const SALEID = invoicedeatils.length > 0 ? invoicedeatils[0].SaleId : null;

            // if (!SALEID) {
            //     console.error('No SaleId found in invoicedeatils!');
            //     setErrorMessage('Invalid SaleId in invoice details!');
            //     setIsLoading(false);
            //     return;
            // }
            const formDataToSend = {
                PartyId: formData.PartyId,
                CreatedBy: userId,
                CompanyId: companyId,
                Amount: formData.Amount,
                //BankId: selectedBank.value,
                BankId: selectedBank?.value ?? null,
                ChequeDate: formatDateForInput(formData.ChequeDate),
                ChequeNo: formData.ChequeNo,
                StatusId: 1,
                chequeDetails: formData.chequeDetails,
                // PaymentTypeId: selectedPaymentmethodType?.value ?? formData.PaymentTypeId,
                PaymentType: selectedPaymentmethodType.value,
                UsedAdvanceAmt: formData.UsedAdvanceAmt,
                ReferenceDate: formatDateForInput(formData.ReferenceDate),
                AdvanceAmt: advanceAmount,
                Remarks: formData.Remarks,
                CreatedDate: new Date(),
            };

            const AdvanceToSend = {
                customerid: formData.PartyId,
                CreatedBy: userId,
                companyid: companyId,
                Advanceamount: advanceAmount,
                Remarks: formData.Remarks,
                saleid: SALEID,
                CreatedDate: new Date(),
            };

            const createData = {
                PaymentAndReceipt: formDataToSend,
                PaymentAndReceiptSale: mappedInvoiceDetails,
                ReceiptAdvance: AdvanceToSend,
            };

            postData('DeliverySaleApi', createData, token)
                .then((response) => {
                    setSuccessMessage('Receipt Created successfully!');
                    setErrorMessage('');

                    history.push('/ReceiptIndex');
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Receipt Create error:', error);
                    setIsLoading(false);
                });

        } catch (error) {
            console.error('Item Create error:', error);
        }
    };


    let advanceAmount = 0;
    if (formData.Amount > 0) {
        advanceAmount = Math.max(0, formData.Amount - invoicedeatils.reduce((acc, item) => acc + item.SaleAmount, 0)).toFixed(2);

    }



    //scroll
    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: 150,
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            msOverflowStyle: 'none',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: 150,
            overflowY: 'auto',
            '::-webkit-scrollbar': {
                width: '8px',
            },
            '::-webkit-scrollbar-thumb': {
                background: '#ccc',
                borderRadius: '4px',
            },
        }),
    };
    return (
        <Fragment>

            <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '900px', overflow: 'auto' }}>
                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.5em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                       
                       
                    `}
                </style>


                <div className=" rounded-lg shadow-lg p-2">

                    <div className='w-full flex'>
                        <div className="banner-style" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', display: 'flex', alignItems: 'center', padding: '10px', borderRadius: '8px', width: '100%' }}>
                            <h4 className="productHead flex-grow linkcolorBlack" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Delivery Receipt</h4>
                            <Button
                                variant="contained"
                                color="error"
                                component={Link}
                                to="/Delivery"
                                className="linkcolor"
                                style={{ marginLeft: '8px' }}
                            >
                                BACK
                            </Button>

                            <Button
                                variant="contained"
                                style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                                onClick={submitData}
                                disabled={isLoading}
                            >
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                            </Button>

                        </div>

                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}


                    <div className="w-full mb-2 flex flex-wrap"> <div className="w-full mb-2 flex flex-wrap">

                        <div className="w-full sm:w-1/5 pl-2  sm:block">
                            <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="customer">
                                Route
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.RouteName}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Remarks"
                                name='RouteName'
                                readOnly
                            />
                        </div>

                        <div className="w-full sm:w-1/3 pl-2  sm:block">
                            <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="customer">
                                Customer
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.CustomerName}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Remarks"
                                name='CustomerName'
                                readOnly
                            />
                        </div>
                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Reference Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.ReferenceDate)}
                                type="date"
                                placeholder="Enter Reference Date"
                                name='ReferenceDate'
                                readOnly
                                onChange={handleChange}
                            />
                        </div>
                        <div className="w-full sm:w-1/5 pl-2  sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                PaymentType
                                <span className="text-red-500">*</span>
                            </label>

                            <Select
                                //value={selectedPaymentmethodType}
                                value={selectedPaymentmethodType || { value: 'cash', label: 'Cash' }}  // Default to "Cash" if not selected
                                onChange={handlePaymentTypeChange}
                                options={paymentmethodOptions.filter(option => option.label !== 'Credit')} // Filter out "credit" option
                                placeholder="PaymentOption"
                                isSearchable
                                styles={customStyles}
                            />
                        </div>

                    </div>
                        {/* Bank Field - conditional rendering */}
                        {showBankField && (
                            <div className="w-full sm:w-1/5 pl-2 sm:block">
                                <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="customer">
                                    Bank
                                    <span className="text-red-500">*</span>
                                </label>

                                <Select
                                    value={selectedBank || { value: '', label: 'Select Bank' }}
                                    onChange={handleBankTypeChange}
                                    options={bankOptions}
                                    placeholder="Select Bank"
                                    isSearchable
                                />

                            </div>


                        )}
                        {showBankField && (

                            <div className="w-full sm:w-1/5 pl-2 hidden sm:block">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="ChequeNo">
                                    {selectedPaymentmethodType.label === "NEFT"
                                        ? "NEFT No"
                                        : selectedPaymentmethodType.label === "RTGS"
                                            ? "RTGS No"
                                            : "Cheque No"}
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    //className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.ChequeNo}
                                    type="text"
                                    placeholder=""
                                    name="ChequeNo"
                                    onChange={handleChange}

                                />
                            </div>
                        )}
                        {showBankField && (
                            <div className="w-full sm:w-1/5 pl-2 hidden sm:block">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="ChequeDate">
                                    {selectedPaymentmethodType.label === "NEFT"
                                        ? "NEFT Date"
                                        : selectedPaymentmethodType.label === "RTGS"
                                            ? "RTGS Date"
                                            : "Cheque Date"}
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formatDateForInput(formData.ChequeDate)}
                                    type="date"
                                    placeholder=""
                                    name="ChequeDate"
                                    onChange={handleChange}
                                />
                            </div>
                        )}

                        {showBankField && (
                            <div className="w-full sm:w-2/5 pl-2 hidden sm:block">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="chequeDetails">
                                    {selectedPaymentmethodType.label === "NEFT"
                                        ? "NEFT Details"
                                        : selectedPaymentmethodType.label === "RTGS"
                                            ? "RTGS Details"
                                            : "Cheque Details"}
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.chequeDetails}
                                    type="text"
                                    placeholder=""
                                    name="chequeDetails"
                                    onChange={handleChange}
                                />
                            </div>
                        )}


                        <div className="w-full mb-2 flex flex-wrap">
                            <div className="w-full sm:w-2/5 pr-2 mb-2 sm:mb-0">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="rate">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Remarks}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Remarks"
                                    name='Remarks'
                                />
                            </div>

                            <div className="w-full sm:w-1/5 pr-2 mb-2 sm:mb-0">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                    Advance Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.UsedAdvanceAmt}
                                    type="text"
                                    placeholder="Enter Amount"
                                    onChange={handleChange}
                                    name='UsedAdvanceAmt'
                                    autoComplete='off'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-full sm:w-1/5 pr-2 mb-2 sm:mb-0">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                    Return Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.ReturnTotalAmt}
                                    type="text"
                                    placeholder="Enter Amount"
                                    onChange={handleChange}
                                    name='ReturnTotalAmt'
                                    autoComplete='off'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-full sm:w-1/5 pr-2 mb-2 sm:mb-0">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                    Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Amount}
                                    type="number"
                                    placeholder="Enter Amount"
                                    onChange={handleChange}
                                    name='Amount'
                                    autoComplete='off'

                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                        </div>

                    </div>
                    <div>
                        <div className="rounded-lg shadow-lg p-2">
                            <div className="w-full mb-2 flex">
                                <div className="w-full mb-2 flex">

                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead sx={{ backgroundColor: '#008080' }}>
                                                <TableRow>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }}>SaleDetails</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }}>Bill Amt</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }}>Pending Amt</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }}>Paid Amt</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }}>Bal Amt</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody sx={{ backgroundColor: 'rgba(38, 166, 154, 0.3)' }}>
                                                {invoicedeatils.map((invdetail, index) => {
                                                    return (
                                                        <TableRow key={invdetail.Id}>
                                                            <TableCell
                                                                style={{
                                                                    borderBottom: '1px solid #F5F5F5',
                                                                    color: 'black',
                                                                    fontWeight: 'bold',
                                                                    padding: '7px',
                                                                    backgroundColor: invdetail.IsType ? 'inherit' : '#FFB2B2', // Conditionally apply red
                                                                }}
                                                            >
                                                                {invdetail.SaleDescription} | {invdetail.Remarks}
                                                            </TableCell>
                                                            <TableCell
                                                                style={{
                                                                    borderBottom: '1px solid #F5F5F5',
                                                                    color: 'black',
                                                                    fontWeight: 'bold',
                                                                    padding: '7px',
                                                                    backgroundColor: invdetail.IsType ? 'inherit' : '#FFB2B2', // Conditionally apply red
                                                                }}
                                                            >
                                                                {invdetail.BillAmount}
                                                            </TableCell>
                                                            <TableCell
                                                                style={{
                                                                    borderBottom: '1px solid #F5F5F5',
                                                                    color: 'black',
                                                                    fontWeight: 'bold',
                                                                    padding: '7px',
                                                                    backgroundColor: invdetail.IsType ? 'inherit' : '#FFB2B2', // Conditionally apply red
                                                                }}
                                                            >
                                                                {invdetail.SaleAmount}
                                                            </TableCell>
                                                            <TableCell
                                                                style={{
                                                                    borderBottom: '1px solid #F5F5F5',
                                                                    color: 'black',
                                                                    fontWeight: 'bold',
                                                                    padding: '7px',
                                                                    backgroundColor: invdetail.IsType ? 'inherit' : '#FFB2B2', // Conditionally apply red
                                                                }}
                                                            >
                                                                {invdetail.Amount}
                                                            </TableCell>
                                                            <TableCell
                                                                style={{
                                                                    borderBottom: '1px solid #F5F5F5',
                                                                    color: 'black',
                                                                    fontWeight: 'bold',
                                                                    padding: '7px',
                                                                    backgroundColor: invdetail.IsType ? 'inherit' : '#FFB2B2', // Conditionally apply red
                                                                }}
                                                            >
                                                                {invdetail.BalanceAmount}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>

                                            {/* <tfoot>
                                                <tr >
                                                    <td className="border-r text-left text-sm " colSpan="4" style={{ backgroundColor: 'rgb(190 242 225)', textAlign: 'right', borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '7px' }}>Advace Amount :

                                                    </td>
                                                    <td className="px-4 py-2 border-r text-right text-sm"
                                                        style={{ backgroundColor: 'rgb(190 242 225)', borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '7px' }}>
                                                        {isNaN(Math.max(0, (formData.Amount + formData.ReturnTotalAmt) - invoicedeatils.reduce((acc, item) => acc + (item.Amount), 0)).toFixed(2))
                                                            ? 0
                                                            : Math.max(0, (formData.Amount + formData.ReturnTotalAmt) - invoicedeatils.reduce((acc, item) => acc + (item.Amount), 0)).toFixed(2)}
                                                    </td>

                                                </tr>
                                            </tfoot> */}
                                            <tfoot>
                                                <tr>
                                                    {/* Cheque Fine Section */}
                                                    <td
                                                        colSpan="1"
                                                        className="border-r text-right text-sm font-bold"
                                                        style={{
                                                            backgroundColor: 'rgb(190 242 225)',
                                                            borderBottom: '1px solid #F5F5F5',
                                                            color: 'black',
                                                            padding: '5px'
                                                        }}
                                                    >
                                                        Cheque Fine: {formData.Chequefine || 0}
                                                    </td>
                                                    <td
                                                        className="px-4 py-2 text-right text-sm font-bold"
                                                        style={{
                                                            backgroundColor: 'rgb(190 242 225)',
                                                            borderBottom: '1px solid #F5F5F5',
                                                            color: 'black',
                                                            padding: '5px'
                                                        }}
                                                    >
                                                        {/* {formData.Chequefine || 0} */}
                                                    </td>


                                                    {/* Advance Amount Section */}
                                                    <td
                                                        colSpan="2"
                                                        className="text-right text-sm font-bold"
                                                        style={{
                                                            backgroundColor: 'rgb(190 242 225)',
                                                            borderBottom: '1px solid #F5F5F5',
                                                            color: 'black',
                                                            padding: '5px'
                                                        }}
                                                    >
                                                        Advance Amount:
                                                    </td>
                                                    <td
                                                        className="px-4 py-2 text-right text-sm font-bold"
                                                        style={{
                                                            backgroundColor: 'rgb(190 242 225)',
                                                            borderBottom: '1px solid #F5F5F5',
                                                            color: 'black',
                                                            padding: '5px'
                                                        }}
                                                    >
                                                        {isNaN(
                                                            Math.max(
                                                                0,
                                                                (formData.Amount + formData.ReturnTotalAmt) -
                                                                invoicedeatils.reduce((acc, item) => acc + (item.Amount || 0), 0)
                                                            ).toFixed(2)
                                                        )
                                                            ? 0
                                                            : Math.max(
                                                                0,
                                                                (formData.Amount + formData.ReturnTotalAmt) -
                                                                invoicedeatils.reduce((acc, item) => acc + (item.Amount || 0), 0)
                                                            ).toFixed(2)}
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </Table>
                                    </TableContainer>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Fragment >
    );
}

export default Despatch;
